export default __webpack_public_path__ + "static/media/Minus.bc291130.svg";